import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class UserProfileForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
            dossiers:[],
            documents:[],
            api:[],
            cost_centers:[],
            cost_centers_list:[],
            providers_list:[],
            providers_list_internal:[],
            providers_list_own:[],
            dossiers_actions:[],
            dossiers_list:[],
            document_list:[],
            documents_actions:[],
            reports_list:[],
            user_actions:[],
            reminders:[],
            my_account: [],
            guest: [],
            plans: [],
            venvers:[],
            has_venvers: false,
        };
    }
    componentDidMount() {
        $('#users_list_').on('select2:select', function (e) {
            var data = e.params.data;
            if(data.id == 'all'){
                $('#users_list').val(null).trigger('change');
                $('#users_list').val('all');
                $('#users_list').trigger('change');
            }else{
                let val = $('#users_list').val()
                var valIndex = val.indexOf("all");
                (valIndex == 0 ? val.splice(valIndex, 1) : null);
                $('#users_list').val(val);
                $('#users_list').trigger('change');
            }
        });
        $('select').on('select2:unselecting', function (e) {
            var id = e.params.args.data.id
            let ide = e.currentTarget.attributes.id.value
            if($('#'+ide).val().length == 1){
                    $('#'+ide).val('all');
            }
            if(id == 'list'){
                var filtered = $('#'+ide).val().filter(function(value, index, arr){
                    if(value != 'delete'){
                    }
                });
                $('#'+ide).val('all')
            }
            if(id == 'all' || id == 'none'){
                return false;
            }
        })
        $('select').on('select2:select', function (e) {
            let ide = e.currentTarget.attributes.id.value
            var data = e.params.data;
            if(data.id == 'delete'){
                let arr = $('#'+ide).val();
                arr.push( "delete");
                $('#'+ide).val(arr);
                $('#'+ide).trigger('change');
            }
            if(data.id == 'edit'){
                let arr = $('#'+ide).val();
                arr.push( "edit");
                $('#'+ide).val(arr);
                $('#'+ide).trigger('change');
            }
            if(data.id == 'edit' || data.id == 'delete'  ){
                let arr = $('#'+ide).val();
                arr.push( "list");
                $('#'+ide).val(arr);
                $('#'+ide).trigger('change');
            }
                if(data.id == 'all' || data.id == 'none'){
                    $('#'+ide).val(null).trigger('change');
                    if(data.id == 'all'){
                        $('#'+ide).val('all');
                    }else{
                        $('#'+ide).val('none');
                    }
                    $('#'+ide).trigger('change');
                }else{
                    let val = $('#'+ide).val()
                    val = val.filter(function(e) {
                        if(e != 'all' && e != 'none'){
                            return e
                        }
                    })
                    $('#'+ide).val(val);
                    $('#'+ide).trigger('change');
                }
        });
        this.getData()
        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    window.blockUI();
                    var form = document.getElementById("frm");
                    var formData = new FormData(form);
                    axios.post('/api/profiles',formData).then(res=>{
                        window.unblockUI();
                        swal.fire({
                            text: "Guardado",
                            icon: "success",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            },
                            timer: 3000
                        }).then(function(result) {
                            window.location.href = '/profiles';
                        });
                    })
                }
            })
        });
    }

    async getData(){
        var url = '/profiles/data';
        const res = await axios.get(url);
        console.log(res.data)
        this.setState({dossiers:  res.data.dossiers});
        this.setState({documents:  res.data.documents});
        this.setState({api:  res.data.api});
        this.setState({cost_centers:  res.data.cost_centers});
        this.setState({cost_centers_list:  res.data.cost_centers_list});
        this.setState({providers_list:  res.data.providers_list});
        this.setState({providers_list_internal:  res.data.providers_list_internal});
        this.setState({providers_list_own:  res.data.providers_list_own});
        this.setState({dossiers_actions:  res.data.dossiers_actions});
        this.setState({dossiers_list:  res.data.dossiers_list});
        this.setState({document_list:  res.data.documents_list});
        this.setState({documents_actions:  res.data.documents_actions});
        this.setState({reports_list:  res.data.reports_list});
        this.setState({user_actions:  res.data.user_actions});
 
        this.setState({reminders:  res.data.reminders});
        this.setState({my_account: res.data.my_account });
        this.setState({guest: res.data.guest });
        this.setState({plans: res.data.plans });
        this.setState({has_venvers: res.data.has_venvers});
    }
    render() {
        const { lang } = this.context;
        return (
        <>
            <form id="frm">
                 
                <div class="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div class="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div class="d-flex align-items-center flex-wrap mr-1">
                            <div class="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 class="text-dark font-weight-bold my-1 mr-5">
                                    {lang.get('messages.nuevo_perfil')}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column-fluid">
                    <div class="container">
                        <div class="card card-custom gutter-b">
                            <div class="card-body">
                                <h5>{lang.get('messages.datos_del_perfil')}</h5>
                                <br />
                                <div class="row justify-content-center text-left">
                                    <div class="col-sm-6 form-group">
                                        <label class="text-left">{lang.get('messages.nombre')}</label>
                                        <input id="title" type="text" name="name" class="form-control form-control-solid"   autoFocus placeholder={lang.get('messages.nombre_del_perfil')} />
                                    </div>
                                    <div class="col-sm-6 form-group">
                                        <label class="text-left">{lang.get('messages.descripcion')}</label>
                                        <input id="title" type="text" name="description" class="form-control form-control-solid"   autoFocus placeholder="Descripción del perfil" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="card card-custom gutter-b">
                            <div class="card-body">
                                <ul class="nav nav-tabs nav-tabs-line">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#kt_tab_pane_1">{lang.get('messages.permisos_de_configuracion')}</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_2">{lang.get('messages.permisos_de_operacion')}</a>
                                    </li>
                                    {/*
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_3">Notificaciones</a>
                                    </li>
                                    */}
                                </ul>
                                <div class="tab-content mt-5" id="myTabContent">
                                    <div class="tab-pane fade show active" id="kt_tab_pane_1" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.usuarios')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="users_list" class="form-control select2" name="users[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.plantillas_de_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers" class="form-control select2" name="dossiers[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.plantillas_de_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="documents" class="form-control select2" name="documents[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="frequency">{lang.get('messages.modificar_frecuencia')}</option>
                                                    <option value="format">{lang.get('messages.modificar_formato')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="duplicate">{lang.get('messages.duplicar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.api')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="api" class="form-control select2" name="api[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.centros_de_costos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="cost_center"  class="form-control select2" name="cost_centers[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Perfiles
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="profiles"  class="form-control select2" name="profiles[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.invitados')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="providers" class="form-control select2" name="providers[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="invite">{lang.get('messages.invitar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="edit">{lang.get('messages.activar__desactivar')}</option>
                                                    <option value="delete_invitations">{lang.get('messages.eliminar_invitaciones')}</option>
                                                    <option value="resend_invitation">Reenviar invitación</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.recordatorios')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="reminders" class="form-control select2" name="reminders[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="list">{lang.get('messages.ver')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="kt_tab_pane_2" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.listado_de_plantillas_de_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_list" class="form-control select2" name="dossiers_list[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    {this.state.dossiers_list.map(function(p,i){
                                                        return <option value={p.id}  >{p.title}</option>
                                                    })}
                                                    <option value="none">Ninguno</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.listado_de_plantillas_de_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_list" name="documents_list[]" multiple="multiple">
                                                <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    {this.state.document_list.map(function(p,i){
                                                        return <option value={p.id}  >{p.title}</option>
                                                    })}
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.listado_de_invitados')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="providers_list" class="form-control select2" name="providers_list[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    {this.state.providers_list.map(function(p,i){
                                                            return <option value={p.persona_provider_id}  >{p.fiscal_name}  </option>
                                                    }) }
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_expedientes')} 
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_actions" class="form-control select2" name="dossiers_actions[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="download">{lang.get('messages.descargar_expediente_completo')}</option>
                                                    <option value="share">{lang.get('messages.compartir_documentos')}</option>
                                                    <option value="request">{lang.get('messages.solicitar_nuevo_documento')}</option>
                                                    <option value="export_reports">{lang.get('messages.exportar_reportes')}</option>
                                                    <option value="delete">Borrar expedientes</option>
                                                    <option value="delete_document_requests">Borrar solicitud de documentos</option>
                                                    <option value="delete_document_request">Borrar solicitud de documento</option>
                                                    <option value="delete_documents">Borrar documentos</option>
                                                    <option value="delete_document">Borrar Documento</option>
                                                    <option value="stop_recurrence">Suspender recurrencia</option>
                                                    <option value="start_recurrence">Reactivar recurrencia</option>
                                                    <option value="replace_dossier">Reemplazar expediente</option>
                                                    <option value="generate_historic">Generar Documentos historicos</option>
                                                    <option value="replace_template">Reemplazar plantilla de documento</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>  
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Mi cuenta
                                            </div>
                                             <div class="col-sm-9">
                                                 <select class="form-control select2" id="my_account" name="my_account[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="add_company">Agregar Empresa</option>
                                                    <option value="update_email">Actualizar Correo</option>
                                                    <option value="make_owner">Convertir a propietario</option>
                                                    <option value="import_templates">Replicar configuración de plantillas</option>
                                                    <option value="conectivities">Conectividades</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Invitado
                                            </div>
                                             <div class="col-sm-9">
                                                 <select class="form-control select2" id="guest" name="guest[]" multiple="multiple">
                                                <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="update_guest_data">Actualizar datos del invitado</option>
                                                    <option value="update_guest_email">Actualizar correo del invitado</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Planes
                                            </div>
                                             <div class="col-sm-9">
                                                 <select class="form-control select2" id="plans" name="plans[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="upgrade_plan">Incrementar plan</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_actions" name="documents_actions[]" multiple="multiple">
                                                <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="load">{lang.get('messages.cargar')}</option>
                                                    <option value="comment">{lang.get('messages.comentar')}</option>
                                                    <option value="download">{lang.get('messages.descargar_documento_compartido')}</option>
                                                    <option value="massive_download">{lang.get('messages.descarga_masiva')}</option>
                                                    <option value="individual_download">{lang.get('messages.descarga_individual__previsualizar')}</option>
                                                    <option value="edit">{lang.get('messages.aprobar__rechazar')}</option>
                                                    <option value="view_document">Ver Document</option>
                                                    <option value="delete_document">Borrar Documento</option>
                                                    <option value="status_log">Bitácora de Estatus</option>
                                                    <option value="delete_document_request">Borrar Solicitud de Documento</option>
                                                    <option value="export_compact_report">Exportar Reporte Compacto</option>
                                                    <option value="export_extra_fields_report_columns">Exportar Reporte Campos Extra con Columnas</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.listado_de_reportes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="reports_list" name="reports_list[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="dossiers"  className="disable_report_list">{lang.get('messages.reporte_de_expedientes')}</option>
                                                    <option value="documents" className="disable_report_list">{lang.get('messages.reporte_de_documentos')}</option>
                                                    <option value="providers" className="disable_report_list">{lang.get('messages.reporte_de_invitados')}</option>
                                                    <option value="invitations" className="disable_report_list">{lang.get('messages.reporte_de_invitaciones')}</option>
                                                    <option value="dossier_templates"  className="disable_report_list">{lang.get('messages.reporte_de_plantilla_de_expedientes')}</option>
                                                    <option value="document_templates" className="disable_report_list">{lang.get('messages.reporte_de_plantilla_de_documentos')}</option>
                                                    <option value="users" className="disable_report_list">{lang.get('messages.reporte_de_usuarios')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_usuarios')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="user_actions" name="user_actions[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="transfer_account"  className="disable_report_list">{lang.get('messages.ceder_derechos_de_cuenta')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div> 
                                        
                                            <div class="row form-group"  style={!this.state.has_venvers ? { display: 'none' } : {}}>
                                                <div class="col-sm-3 text-right col-form-label">
                                                    Venvers
                                                    <br /> 
                                                </div>
                                                <div class="col-sm-9">
                                                    <select class="form-control select2" id="venvers" name="venvers[]" multiple="multiple">
                                                        <option value="all"  selected="selected">Todas</option>
                                                        <option value="connect">Conectar</option>
                                                        <option value="list_providers">Ver Listado de Proveedores</option>
                                                        <option value="configure">Configurar</option>
                                                        <option value="none">Ninguna</option>
                                                    </select>
                                                </div>
                                            </div> 
                                             {!this.state.has_venvers && (
                                                    <input type="hidden" name="venvers[]" value="all" />
                                                )}
                                        
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            <span class="card-label font-weight-bold font-size-h4 text-dark-50">{lang.get('messages.expedientes_internos')}</span>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.listado_de_invitados_internos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="providers_list_internal" class="form-control select2" name="providers_list_internal[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    {this.state.providers_list_internal.map(function(p,i){
                                                            return <option value={p.persona_provider_id}  >{p.fiscal_name}  </option>
                                                    }) }
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_actions_internal" class="form-control select2" name="dossiers_actions_internal[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="transfer">{lang.get('messages.transferir')}</option>
                                                    <option value="download">{lang.get('messages.descargar_expediente_completo')}</option>
                                                    <option value="share">{lang.get('messages.compartir_documentos')}</option>
                                                    <option value="massive_upload">{lang.get('messages.carga_masiva')}</option>
                                                    <option value="request">{lang.get('messages.solicitar_nuevo_documento')}</option>
                                                    <option value="stop_recurrence">Suspender recurrencia</option>
                                                    <option value="start_recurrence">Reactivar recurrencia</option>
                                                    <option value="replace_dossier">Reemplazar expediente</option>
                                                    <option value="generate_historic">Generar Documentos historicos</option>
                                                    <option value="replace_template">Reemplazar plantilla de documento</option>
                                                    <option value="delete">Borrar expediente</option>
                                                    <option value="delete_documents">Borrar documentos</option>
                                                    <option value="delete_document_requests">Borrar solicitudes de documentos</option>
                                                    <option value="delete_document_request">Borrar solicitud de documento</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_actions_internal" name="documents_actions_internal[]" multiple="multiple">
                                                <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="load">{lang.get('messages.cargar')}</option>
                                                    <option value="comment">{lang.get('messages.comentar')}</option>
                                                    <option value="download">{lang.get('messages.descargar_documento_compartido')}</option>
                                                    <option value="massive_download">{lang.get('messages.descarga_masiva')}</option>
                                                    <option value="individual_download">{lang.get('messages.descarga_individual__previsualizar')}</option>
                                                    <option value="edit">{lang.get('messages.aprobar__rechazar')}</option>
                                                    <option value="export_compact_report">Exportar Reporte Compacto</option>
                                                    <option value="export_extra_fields_report_columns">Exportar Reporte Campos Extra con Columnas</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.listado_de_reportes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="reports_list_internal" name="reports_list_internal[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="dossiers"  className="disable_report_list">{lang.get('messages.reporte_de_expedientes')}</option>
                                                    <option value="documents" className="disable_report_list">{lang.get('messages.reporte_de_documentos')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                <span class="card-label font-weight-bold font-size-h4 text-dark-50">Expedientes Propios</span>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_actions_own" name="documents_actions_own[]" multiple="multiple">
                                                <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="load">{lang.get('messages.cargar')}</option>
                                                    <option value="comment">{lang.get('messages.comentar')}</option>
                                                    <option value="download">{lang.get('messages.descargar_documento_compartido')}</option>
                                                    <option value="massive_download">{lang.get('messages.descarga_masiva')}</option>
                                                    <option value="individual_download">{lang.get('messages.descarga_individual__previsualizar')}</option>
                                                    <option value="edit">{lang.get('messages.aprobar__rechazar')}</option>
                                                    <option value="export_compact_report">Exportar Reporte Compacto</option>
                                                    <option value="export_extra_fields_report_columns">Exportar Reporte Campos Extra con Columnas</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.listado_de_reportes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="reports_list_own" name="reports_list_own[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="dossiers"  className="disable_report_list">{lang.get('messages.reporte_de_expedientes')}</option>
                                                    <option value="documents" className="disable_report_list">{lang.get('messages.reporte_de_documentos')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_actions_own" class="form-control select2" name="dossiers_actions_own[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="download">{lang.get('messages.descargar_expediente_completo')}</option>
                                                    <option value="share">{lang.get('messages.compartir_documentos')}</option>
                                                    <option value="stop_recurrence">Suspender recurrencia</option>
                                                    <option value="start_recurrence">Reactivar recurrencia</option>
                                                    <option value="generate_historic">Generar Documentos historicos</option>
                                                    <option value="replace_template">Reemplazar plantilla de documento</option>
                                                    <option value="delete">Borrar expediente</option>
                                                    <option value="delete_documents">Borrar documentos</option>
                                                    <option value="delete_document_requests">Borrar solicitudes de documentos</option>
                                                    <option value="delete_document_request">Borrar solicitud de documento</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                    <input type="hidden" value='["all"]' name="user_notifications"/>
                                    {/*   <div class="tab-pane fade" id="kt_tab_pane_3" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Notificaciones
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="user_notifications" class="form-control select2" name="user_notifications[]" multiple="multiple">
                                                    <option value="all"  selected="selected">Todos</option>
                                                    <option value="user_notifications">Enviar notificaciones a usuarios</option>
                                                    <option value="none">Ninguno</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-end mt-6">
                            <div class="col-sm-8 text-right">
                                <a href="/profiles" class="btn btn-lg btn-secondary">
                                {lang.get('messages.cancelar')}
                                </a>
                                <button id="btnPublish" type="button" class="btn btn-lg btn-primary ml-4">
                                {lang.get('messages.guardar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
        );
    }
}

export default UserProfileForm;

if (document.getElementById('UserProfileForm')) {
    ReactDOM.render(<UserProfileForm />, document.getElementById('UserProfileForm'));
}
